import { AuthBody, RegAuthBody } from '../models/AuthBody';
import storageService, { STORAGE_KEYS } from './storageService';

export default {
  get authBody() {
    return storageService.getItem<AuthBody>(STORAGE_KEYS.AUTH);
  },

  get token(): string {
    return storageService.getItem<AuthBody>(STORAGE_KEYS.AUTH)?.tokens
      ?.accessToken;
  },

  get tokens() {
    return storageService.getItem<AuthBody>(STORAGE_KEYS.AUTH)?.tokens;
  },

  get refreshToken(): string {
    return storageService.getItem<AuthBody>(STORAGE_KEYS.AUTH)?.tokens
      ?.refreshToken;
  },

  get registrationToken(): string {
    return storageService.getItem<RegAuthBody>(STORAGE_KEYS.AUTH)
      ?.registrationToken;
  },

  saveAuthBody(authBody: Omit<AuthBody | RegAuthBody, 'user'>) {
    storageService.setItem(STORAGE_KEYS.AUTH, authBody);
  },

  removeAuthBody() {
    storageService.removeItem(STORAGE_KEYS.AUTH);
  },
};
